import React from 'react'
import { MotionButton, MotionDiv, MotionSection } from '../motion/Motion'

export default function AboutCtaSection() {
  return (
    <MotionSection className="w-full py-12 lg:py-16">
      <div
        className="relative w-full bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: "url('/images/sectionimages/about%20cta.png')" }}
      >
        <div className="w-full min-h-[360px] sm:min-h-[420px] lg:min-h-[520px] flex items-center">
          <div className="w-[96%] mx-auto">
            <MotionDiv className="ml-auto w-full max-w-xl lg:max-w-2xl" delay={0.06}>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-white">
                TOUGH ON WEATHER. EASY ON THE EYES.
              </h2>
              <p className="mt-4 text-sm sm:text-base leading-relaxed text-white/90">
                Welcome to our latest collection of made-to-last, all weather, hardwearing doormats!
              </p>
              <p className="mt-4 text-sm sm:text-base leading-relaxed text-white/90">
                If you're looking for a one of kind doormat to stand the test of time and effectively keep dirt and moisture outside, you
                will love the extraordinary quality of our Everlast Range of doormats.
              </p>

              <div className="mt-6">
                <button className="rounded-full bg-pink-500 px-6 py-2 text-sm font-semibold text-white shadow hover:bg-pink-600 transition-colors">
                  <MotionButton>Shop Now</MotionButton>
                </button>
              </div>
            </MotionDiv>
          </div>
        </div>
      </div>
    </MotionSection>
  )
}
